import module from 'contabilidad/polizasexternas/module'
import template from './template.html'

export class ContabilidadPolizasexternasAlgodonerosIngresosListaMovimientosFacturasComponent {
  data
  procesando = false
  error = null

  constructor(PolizasExternasAlgodonerosFacturasService) {
    this.polizasExternasAlgodonerosFacturasService = PolizasExternasAlgodonerosFacturasService
  }

  $onInit() {
    this.promise = this.polizasExternasAlgodonerosFacturasService.get(this.movimientoId)
      .then((response) => { this.data = response.data })
      .then(() => {
        this.total = this.data.length ? this.data.reduce((total, item) => item.importe + total, 0) : 0
      })
  }

  cerrar() {
    this.onClose()
  }

  eliminar(item) {
    if (this.procesando) return

    this.procesando = true
    this.error = null

    this.polizasExternasAlgodonerosFacturasService.delete(this.movimientoId, item.facturaId, item.importe)
      .then(() => {
        this.data = this.data.filter((factura) => factura.facturaId !== item.facturaId)
        this.onChange({
          $event: {
            facturas: this.data.length,
            totalvinculado: this.data.length ? this.data.reduce((total, item) => item.importe + total, 0) : 0,
          }
        })
      })
      .finally(() => {
        this.procesando = false
        this.total = this.data.length ? this.data.reduce((total, item) => item.importe + total, 0) : 0
      })
  }
}

module.component('contabilidadPolizasexternasAlgodonerosIngresosListaMovimientosFacturas', {
  controller: ContabilidadPolizasexternasAlgodonerosIngresosListaMovimientosFacturasComponent,
  template,
  bindings: {
    data: '<',
    movimientoId: '<',
    onChange: '&',
    onClose: '&',
  },
})




// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/algodoneros/ingresos/lista/movimientos/facturas/component.js